import React from 'react';
import { tideChartsPath } from 'utils/urls/tideCharts';
import MetaTags from '../MetaTags';
import config from '../../config';

interface Props {
  spotName: string;
  spotId: string;
  spotSlug: string;
}

const TideChartsPageMeta: React.FC<Props> = ({ spotName, spotId, spotSlug }) => {
  const pageTitle = config.meta.title.tideChartsPage(spotName);
  const metaDescription = config.meta.description.tideChartsPage(spotName);
  const urlPath = tideChartsPath(spotId, spotSlug);

  return <MetaTags title={pageTitle} description={metaDescription} urlPath={urlPath} />;
};

export default TideChartsPageMeta;
